export const PRIZM_OVERLAY_BACKDROP_NO_POINTERS = 'no-pointers';
